console.log('window.$223',window.$)
if(window.jQuery && !window.$) {
  window.$ = window.jQuery
}
window.$ && $(document).ready(function() {
  imageWidthHeight();
  $('.product-section--content').on( 'ready.flickity', function() {
    imageWidthHeight();
    setTimeout(function(){
      const height = $('.product-section--content .flickity-slider').css('height');
      const height1 = $('.product-section--content .flickity-slider .productitem--actions').css('height');
      const height2 = parseInt(height)+parseInt(height1)
      $('.product-section--content').css('height', height2+'px');
    }, 1000)
  });
  const isHavaLeftDom = $('.faqs-content .faqs-content-left .faqs-content-item');
  const isHavaRightDom = $('.faqs-content .faqs-content-right .faqs-content-item');
  if (isHavaLeftDom.length == 0) {
    $('.faqs-content .faqs-content-left').hide()
  }
  if (isHavaRightDom.length == 0) {
    $('.faqs-content .faqs-content-right').hide()
  }
  observeElementRender('#app-embed', () => {
   setTimeout(function(){
    //changeFromDom();
    changeFromDom1();
     $('#AcUNQMHJzN3hCSUxKZ__forms_inline_qYgBNq').css('opacity', 1);
   }, 1500)
  });
  observeElementRender('.collection-list__container', () => {
    collectionImageWidthHeight()
  })
  observeElementRender('.announcement-bar', () => {
     stickyHeader();
  })
  observeElementRender()
  contactFormSubmit();
  $(document).on('click', '.klarna-message-model .klarna-message-model-payment-close', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  });
  
  $(document).on('click', '.klarna-message-model .payment-close-span', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  });
  
  $(document).on('click', '.klarna-message-block-view .klarna-message-link', function(e) {
    $('.klarna-message-model').css('display', 'flex');
    $('body').addClass('cartover');
  });
})
function imageWidthHeight() {
  const productitem = $('.productitem .productitem__image-container');
  for (let i = 0; i < productitem.length; i++ ) {
    const  width = $(productitem[i]).width();
    $(productitem[i]).find('.productitem--image').css('height', width+'px').css('width','auto').css('margin','0 auto').css('max-width', '100%');
    const imgDom = $(productitem[i]).find('.productitem--image img');
    for(let j =0; j < imgDom.length; j++) {
      const src1 = $(imgDom[j]).attr('src');
      $(imgDom[j]).attr('srcset', src1);
    }
    //console.log($(productitem[i]).find('.productitem--image img').attr('src')) 
  }
}
function collectionImageWidthHeight() {
  const collectionitem = $('.listcollections--section .collection-list__container .collection__item');
  for (let i = 0; i < collectionitem.length; i++ ) {
    const  width = $(collectionitem[i]).width();
    $(collectionitem[i]).find('.collection__item-image').css('height', width+'px')
  }
}
function changeFromDom1() {
  const shadowEmbed = document.querySelector('#AcUNQMHJzN3hCSUxKZ__forms_inline_qYgBNq #app-embed');
  const shadowEmbedDom = shadowEmbed ? shadowEmbed.shadowRoot : null;
  if (shadowEmbedDom) {
    shadowEmbedDom.querySelector('#app-embed').insertAdjacentHTML('afterbegin',`<style class="customStyle">
      @media only screen and (min-width: 991px) {
        ._inline_stahb_47 {
         justify-content: flex-start !important;
        }
        ._inline_stahb_47 section[data-testid=form-container] {
          max-width: 600px !important;
          background: #f6f7fb;
          padding: 20px;
        }
     }
     @media only screen and (max-width: 990px) {
       ._formFieldContainer_1ydxd_5{
         margin-block: 2px !important;
       }
     }
     @media only screen and (min-width: 991px) and (max-width: 1500px) {
        ._inline_stahb_47 section[data-testid=form-container] {
           max-width: 420px !important;
        }
      }
    </style>`)
  }
}
function changeFromDom() {
  const shadowEmbed = document.querySelector('#AaGNMYjFCQThOamVVL__forms_inline_CGJMyx #app-embed');
  const shadowEmbedDom = shadowEmbed ? shadowEmbed.shadowRoot : null;
  if (shadowEmbedDom) {
    const childDom = shadowEmbedDom.querySelectorAll('#form-container-ref ._formFieldContainer_1ydxd_5 ');
    let str = ''
    const mess = shadowEmbedDom.querySelector('#form-container-ref button[type=submit]').outerHTML;
    let str1 = ''
    for (let i = 0; i < childDom.length; i ++ ) {
       const idName = childDom[i].querySelector('input')?.getAttribute('id');
       if (idName) {
         str += childDom[i].outerHTML
       } else {
         str1 += childDom[i].outerHTML
       }
    }
    shadowEmbedDom.querySelector('#form-container-ref form[data-testid=form]').innerHTML='<div class="leftItem" >'+str+'</div>'+'<div class="rightItem">'+str1+mess+'</div>';
    shadowEmbedDom.querySelector('#app-embed').insertAdjacentHTML('afterbegin',`<style class="customStyle">
      @media only screen and (min-width: 991px) {
       form[data-testid=form] {
          flex-direction: row !important;
          background: #002e46 !important;
          padding: 40px 2px !important;
          justify-content: center;
        }
       section[data-testid=form-container]{
          max-width: 100% !important;
        }
       ._formFieldContainer_1ydxd_5 {
          margin-bottom: 10px;
          margin-block: 10px !important;
          width: 370px;
        }
       .rightItem ._textArea_17mgw_1{
         height: 120px;
       }
     button[data-testid=btn-form-submit] {
         float: right !important;
          border: 1px solid #ccc !important;
          background: #fff !important;
          color: #fff !important;
          width: 120px !important;
          padding: 12px !important;
          background: none !important;
          margin-top: 10px !important;
       }
     ._formInputFieldLabel_1ydxd_37 {
         top: 6px!important;
       }
      output[role="alert"] {
         display: none;
       }
      ._gridItemContent_stahb_257 {
         padding-bottom: 0px !important;
       }
     }
     @media only screen and (max-width: 990px) {
      ._formFieldContainer_1ydxd_5 {
          margin-bottom: 10px;
          margin-block: 20px !important;
        }
        .rightItem ._formFieldContainer_1ydxd_5  {
          margin-block-start: -10px !important;
        }
        button[data-testid=btn-form-submit] {
           width: 100% !important;
          border-radius: 4px !important;
          padding-left: 0px !important;
          padding-right: 0px !important;
          margin-block-start: 25px !important;
        }
      form[data-testid=form] {
           justify-content: center;
            align-items: center;
         }
         .leftItem, .rightItem {
           min-width: 350px;
         }
     }
    </style>`)
    shadowEmbedDom.querySelector('#form-container-ref button[type=submit]').addEventListener('click', function(){
      const name =  shadowEmbedDom.querySelector('#first_name').value
      const email = shadowEmbedDom.querySelector('#email').value
      const company = shadowEmbedDom.querySelector('._formInputField_237zm_7').value
      const message = shadowEmbedDom.querySelector('._textArea_17mgw_1').value
      const formDom = shadowEmbedDom.querySelector('#form-container-ref form[data-testid=form] ')
      // $(formDom).find('.errorTip').remove();
      // if(!name || !email || !company || !message){
      //   const bottom = $(window).width() > 990 ? "position: absolute; bottom: 40px;" : "position: absolute; bottom: 70px;"
      //   $(formDom).append('<div class="errorTip" style="'+bottom+'"><output class="_formError_1ydxd_20">First name, email, company, message is required</output</div>')
      // }
      // setTimeout(function(){
      //    const dom = shadowEmbedDom.querySelectorAll('#form-container-ref form[data-testid=form]  output[role="alert"]');
      //    for (i =0; i <dom.length; i ++) {
      //    // dom[i].remove()
      //   } 
      // }, 100)
    })
  }
}

function observeElementRender(selector, callback) { // 监听元素是否加载
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector(selector)) {
      callback();
      obs.disconnect(); // 停止观察避免内存泄漏
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

/*---wishlist begin ---*/
const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log(
    '[Shopify Wishlist] Wishlist Product List Loaded ✅',
    event.detail.wishlist
  );
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log(
    '[Shopify Wishlist] Wishlist Buttons Loaded ✅',
    event.detail.wishlist
  );
});

const fetchProductCardHTML = (queryString) => {
  const productTileTemplateUrl = `/search?type=product&section_id=template--25140683669798__wishlist_3aHmMN&limit=8&q=${queryString}`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const html = document.createElement('div');
      html.innerHTML = res;
      return html.querySelector(selectors.grid);
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for ids: ${queryString}`,
        err
      )
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  if(wishlist.length<=0){
    //let noResult = document.querySelector('.productgrid--no-results-title');
    //noResult.textContent = noResult.dataset.emptyText;
    //return;
  }
  const queryString = wishlist.map((item) => 'id:' + item).join(' OR ');
  const responses = await fetchProductCardHTML(queryString);
  if(responses){
    grid.innerHTML = responses.innerHTML;
    if (window.rimg_shopify_dist_index_es){
      window.rimg_shopify_dist_index_es.watch(document.querySelector('.wishlist__grid'));
    }
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
  }else{
    //let noResult = document.querySelector('.productgrid--no-results-title');
    //noResult.textContent = noResult.dataset.emptyText;
  }
  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productId || false;
    if (!productHandle)
      return console.error(
        '[Shopify Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.'
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
      button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};
/*---wishlist end ---*/

function addPrice() {
    const rangeList = $('.product-request-price-range .product-request-price-range-list li');
    const rangePrice = []
    for (let i = 0 ; i < rangeList.length; i ++) {
      const priceTitle = $(rangeList[i]).find('.price-range-list-title').text();
      const priceTitleTrim = priceTitle.replace('pieces', '').trim();
      const priceTitleTrimData =  priceTitleTrim.split('-');
      const maxPrice = priceTitleTrimData && priceTitleTrimData.length > 0 ? priceTitleTrimData[1] : 0; // 最大价格
      const minPrice = $(rangeList[i]).find('.price-range-list-content').attr('data-min-number'); // 最小价格
      const finalprice = $(rangeList[i]).find('.price-range-list-content').attr('data-finalprice');//单价
      rangePrice.push({
        minPrice: minPrice,
        maxPrice: maxPrice,
        finalprice: finalprice
      })
    }
    $(document).on('click', '.quantity-selector-outer .quantity-selector__button-wrapper--plus button[name="plus"], .quantity-selector-outer .quantity-selector__button-wrapper--minus button[name="minus"]', function(e) {
        commontPrice(rangePrice)
    })
    $('input[name="quantity"]').on('change', function(e){
       commontPrice(rangePrice)
    })
  
    function commontPrice(rangePrice) {
      const count = $('input[name="quantity"]').val();
      const curPrice = $('.product-details .product-pricing').attr('data-price');//当前价格
      const curComparePrice = $('.product-details .product-pricing').attr('data-compare-price');//当前比较价格
      const comparePrice = Number(curComparePrice.substring(1));
      const price = Number(curPrice.substring(1));
      const price1 = curPrice.substring(0,1);
      const totalPrice = ( Number(count) * price*100 )/100; 
      let totalPrice1 = Number(totalPrice.toFixed(2));//先算出正常总价
      const totalComparePrice = ( Number(count) * comparePrice*100 )/100;
      const totalComparePrice1 = Number(totalComparePrice.toFixed(2));
      const savePrice = Number(totalComparePrice1) - Number(totalPrice1);
      const savePricechange = Number(savePrice.toFixed(2));
      const isHaveDom = $('.product-request-price-range .product-request-price-range-list');
      if (isHaveDom.length > 0) {
        $('.product-details .product__price .price__current--on-sale .money').text(price1+totalPrice1);
        $('.product-details .product__price .price__compare-at .money').text(price1+totalComparePrice1);
        $('.product-details .product-pricing .money[data-price-money-saved]').text(price1+savePricechange);
        rangePrice.forEach(v =>{ 
          const totalPriceChange = ( Number(count) * v.finalprice*100 )/100;
          const totalPriceChange1 = Number(totalPriceChange.toFixed(2));
          const savePrice1 = Number(totalComparePrice1)- Number(totalPriceChange1);
          const savePricechange1 = Number(savePrice1.toFixed(2));
          if ((totalPrice1 > v.minPrice &&  totalPrice1 < v.maxPrice) || ( !v.maxPrice  && totalPrice1 > v.minPrice )) {
            $('.product-details .product__price .price__current--on-sale .money').text(price1+totalPriceChange1);
            $('.product-details .product-pricing .money[data-price-money-saved]').text(price1+savePricechange1);
          }
        })
      }
    }
}

function contactFormSubmit(){
  //document.querySelector('.contact-from-content-wrap .submit-btn').addEventListener('click', function(event){
  $(document).on('click', '.contact-from-content-wrap .submit-btn', function(event) {
    event.preventDefault();
    const inputDom = $(".contact-from-content-wrap .leftInputItem");
    inputDom.removeClass('errorTip');
    inputDom.find('.errorTipName').text();
    const isPass = checkField();
    if (isPass) {
      const shadowEmbed = document.querySelector('#AaGNMYjFCQThOamVVL__forms_inline_CGJMyx #app-embed');
      const shadowEmbedDom = shadowEmbed ? shadowEmbed.shadowRoot : null;
      if (shadowEmbedDom) {
        shadowEmbedDom.querySelector('input[data-testid="field-first_name"]').value = $("#nameItem").val();
        shadowEmbedDom.querySelector('input[data-testid="field-email"]').value = $("#emailItem").val();
        shadowEmbedDom.querySelector('input[data-testid="field-email"]').dispatchEvent(new Event('input'));
        shadowEmbedDom.querySelector('input[data-testid="field-custom#company"]').value = $("#companyItem").val();
        shadowEmbedDom.querySelector('textarea[name="custom#message"]').value = $("#messageItem").val();
        setTimeout(function(){
          shadowEmbedDom.querySelector('button[data-testid="btn-form-submit"]').click();
          submitSuccess()
        }, 10)
      }
    }
  })

  $(document).on('change', '.contact-from-content-wrap .leftInputItem input, .contact-from-content-wrap .leftInputItem textarea', function() {
     const curValue = $(this).val();
     const parentDom = $(this).parents('.leftInputItem');
     const id = $(this).attr('id');
     if (curValue) {
       const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
       if (id == 'emailItem') {
         if (!regex.test(curValue)){
            parentDom.find('.errorTipName').text( 'The email format is incorrect (e.g. xxx@163.com).');
         } else {
           parentDom.removeClass('errorTip')
         }
       } else {
         parentDom.removeClass('errorTip')
       }
     }
  })

  function submitSuccess() {
    let check_number = 0;
    let formsInterval = setInterval(function() {
      if(check_number >= 1000){
        clearInterval(formsInterval);
      }
      check_number++;
      const shadowEmbed = document.querySelector('#AaGNMYjFCQThOamVVL__forms_inline_CGJMyx #app-embed');
      const shadowEmbedDom = shadowEmbed ? shadowEmbed.shadowRoot : null;
      if (shadowEmbedDom) {
        const suceessDom = shadowEmbedDom.querySelector('section[data-testid="banner-success"]');
        if (suceessDom) {
          clearInterval(formsInterval);
          showCustomModal('Submit Successfully')
          window.location.reload();
        }
      }
    }, 100)
  }

  function checkField() {
    const inputDom = $(".contact-from-content-wrap .leftInputItem");
    let isPass = true;
    for(let i = 0; i < inputDom.length; i ++ ) {
      const dom = $(inputDom[i]).find('input');
      const dom1 = $(inputDom[i]).find('textarea')
      const inputData = $(inputDom[i]).find('input').val();
      const textareaData = $(inputDom[i]).find('textarea').val();
      const idName = $(inputDom[i]).find('input').attr('id');
      if (dom.length > 0 && !inputData) {
        $(inputDom[i]).addClass('errorTip');
        isPass = false;
        let error = ''
        if (idName == 'nameItem' ) {
          error = 'Name is Required'
        } else if(idName == 'emailItem' ) {
          error = 'Email is Required'
        } else if(idName == 'companyItem' ) {
          error = 'Company is Required'
        }
        $(inputDom[i]).find('.errorTipName').text(error)
      }
      if (dom1.length > 0 && !textareaData) {
        $(inputDom[i]).addClass('errorTip');
        isPass = false;
        $(inputDom[i]).find('.errorTipName').text('Message is Required')
      }
      if (idName == 'emailItem' && inputData) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(inputData)) {
          const error = 'The email format is incorrect (e.g. xxx@163.com).'
          $(inputDom[i]).find('.errorTipName').text(error);
          isPass = false;
        }
      }
    }
    return isPass
  }
  
  function showCustomModal(content = 'successfully') {
    $('.ant-message').css('display', 'block');
    $('.ant-message .ant-message-success span').text(content)
    setTimeout(function () {
        hideCustomModal();
    }, 2000);
  }
  function hideCustomModal() {
   $('.ant-message').css('display', 'none');
  }
}

function stickyHeader() {
  const height = $('.site-announcement').css('height');
  const barHeight = $('.sections-utility-bar').css('height');
  const height1 = height.split('px').length > 0 ? height.split('px')[0] : 0
  const barHeight1 = barHeight.split('px').length > 0 ? barHeight.split('px')[0] : 0
  const heightTotal = Number(height1) + Number(barHeight1);
  $('.site-announcement').css({'position':'sticky','top': '0px', 'z-index': 1000}); 
  !$('.sections-utility-bar').is(':hidden') && $('.sections-utility-bar').css({'position':'sticky','top': height, 'z-index': 1000});
  $('.site-header-wrapper .site-header').css({'position':'sticky','top': heightTotal+'px'})
}
